// Actions
export const SHOW_NEW_VERSION_DIALOG = 'SHOW_NEW_VERSION_DIALOG';

// Reducer
interface VersionCheckerAction {
  type: string;
}

export interface VersionCheckerReducerState {
  showNewVersionDialog: boolean;
}

const initialState: VersionCheckerReducerState = {
  showNewVersionDialog: false,
};

export const versionCheckerReducer =
  (
    state: VersionCheckerReducerState = initialState,
    action: VersionCheckerAction,
  ): VersionCheckerReducerState => {
    switch (action.type) {
      case SHOW_NEW_VERSION_DIALOG:
        return {
          ...state,
          showNewVersionDialog: true,
        };
      default:
        return state;
    }
  };

// Action Creators
export const showNewVersionDialog = () => {
  return (dispatch: Function) => {
    dispatch({ type: SHOW_NEW_VERSION_DIALOG });
  };
};
